/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-11-04 17:52:13
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-11-26 18:13:59
 * @FilePath: \mpc-monorepo\features\mpc-common\src\features\MPCDemand\KOLInquiryForQuotation\SupplierDesignatedKOLTable\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { forwardRef, useMemo, useState, useRef, useImperativeHandle, useEffect } from 'react';
import {
  ProTablePlusForm,
  ProTablePlusFormRef,
} from '#components/ProTablePlusForm';
import type { AddGroupFormColumn } from '#components/ProTablePlusForm/addGroupTable';
import { CurrencyEnum, DemandSourceKolCreateCmd, DemandSourceSupplierKolVo, DemandSourceCustomInspectionVo } from '#services/api';
import { ProCard, ProTablePlus, useScreenAdapterContext } from '@bedrock/eed-react';
import { Button, Collapse, Divider, Input, Modal, Space, Switch, Table, Tabs, Tag } from '@bedrock/components';
import { Plus, SignIn } from '@bedrock/icons-react';
import useDesignatedExpertColumns from '../cells/useDesignatedExpertColumns';
import { ReportedSwitch } from './ReportedSwitch';
import { CollapseTablePanel } from '#components';
import classNames from "classnames/bind";
import styles from "./index.less";
import DescriptionsFormItem from '#components/DescriptionsFormItem';
import { useMemoizedFn } from 'ahooks';
import { v4 as uuidv4 } from 'uuid';
import { EllipsisTooltip, FullScreenButton } from '@mpc/components';

const cx = classNames.bind(styles)

type SupplierDemandSourceMatchTableSingleProps = {
  detailData?: any;
  /** 表格数据 */
  value?: any[];
  /** 数据变化回调 */
  onChange?: (value: any[]) => void;
  /** 是否是视图 */
  view?: boolean;
  /** 视图币种 */
  viewCurrency?: CurrencyEnum;
  /** 类名 */
  className?: string;
  /** 定制排查 */
  demandSourceCustomInspection?: DemandSourceCustomInspectionVo & { $demand_source_supplier_kol_vos: DemandSourceSupplierKolVo[] };
  /** 索引 */
  index?: number;
  /** 批量导入方法 */
  handleBatchSubmission?: () => void;
}

function SmallLabelValue({ label, value, valueClassName, valueClamp = 1 }: { label: React.ReactNode, value: React.ReactNode, valueClassName?: string, valueClamp?: number }) {
  return <div className="flex justify-start items-center gap-1 w-full self-stretch shrink-0 mt-1" >
    <div className="text-xs font-normal text-color-3 whitespace-nowrap">{label}:</div>
    <div className={cx('text-xs font-normal text-color-1', valueClassName)}>
      <EllipsisTooltip
        text={value as string || '--'}
        clamp={valueClamp}
      />
    </div>
  </div>
}


/**
 * 需求源匹配表格组件
 */
export const SupplierDemandSourceMatchTableSingle = forwardRef<ProTablePlusFormRef, SupplierDemandSourceMatchTableSingleProps>(
  (props, ref) => {
    const {
      detailData,
      value = [],
      view = false,
      onChange,
      className,
      index,
      demandSourceCustomInspection,
      handleBatchSubmission,
    } = props;

    const { columnsConfig } = useDesignatedExpertColumns({
      view,
      changeData: onChange,
      l3_category_id: detailData?.l3_category_id,
    });

    const [isFullscreen, setIsFullscreen] = useState(false);
    const { viewBase } = useScreenAdapterContext();

    // 定制排查表格字段
    const customInspectionTableColumns = useMemo(() => {
      return demandSourceCustomInspection?.custom_inspection_fields?.map((n, index) => {
        const title = (<>
          <span>{n.field_name}</span>
          <SmallLabelValue label="要求" value={n.plan_remark} />
          <SmallLabelValue label="示例" value={n.value_example} />
        </>)
        return {
          title: !view ? title : <div>{title}</div>,
          dataIndex: ['demand_source_custom_inspection_fields_value', index, 'value'],
          width: 280,
          editRender: () => ({
            name: 'input',
            editable: !view,
            props: {
              // placeholder: n.value_example ? ('例:' + n.value_example) : '请输入',
              placeholder: '请输入',
              maxLength: 200,
              showCount: true,
            },
            rule: {
              required: !view,
              message: '请输入',
            },
          }),
        }
      }) || [];
    }, [demandSourceCustomInspection]);

    const columns: AddGroupFormColumn[] = useMemo(() => {
      return [
        columnsConfig.index,
        {
          ...columnsConfig.main_platform,
          fixed: 'left',
          width: 100 * viewBase,
          editRender: () => ({
            name: 'input',
            editable: false,
          }),
          render(_, record) {
            return _ || demandSourceCustomInspection?.main_platform || '--';
          },
          rule: {},
        },
        {
          ...columnsConfig.main_platform_account,
          fixed: 'left',
        },
        columnsConfig.main_platform_link,
        columnsConfig.exclusiveSign,
        columnsConfig.initialQuote,
        columnsConfig.count,
        columnsConfig.remarkDto,
        columnsConfig.cpm,
        columnsConfig.cpm_pv,
        columnsConfig.cpm_uv,
        columnsConfig.platform_quote_price,
        columnsConfig.platform_cpm,
        columnsConfig.platform_cpm_pv,
        columnsConfig.platform_cpm_uv,
        ...customInspectionTableColumns,
        {
          title: '操作',
          dataIndex: 'actions',
          width: 64,
          fixed: 'right',
          show: !view,
          render: (v: any, record: any, index: number) => {
            return <Button type="link" danger onClick={() => onChange?.(value.filter((item, i) => i !== index))}>删除</Button>
          }
        },
      ].filter((n: any) => n && n?.show !== false) as AddGroupFormColumn[];
    }, [columnsConfig, detailData?.l3_category_id]);

    const localRef = useRef<ProTablePlusFormRef>(null);
    const wrapperRef = useRef(null);
    useImperativeHandle(ref, () => ({
      ...localRef.current,
      validateFields: () => {
        
        return localRef.current?.validateFieldsAndScroll?.();
      }
    }) as ProTablePlusFormRef, [localRef]);

    const formatValue = useMemo(() => {
      return value.map((item) => {
        // bedrock-eed表格的问题
        const newDemandSourceCustomInspectionFieldsValueObj = item.demand_source_custom_inspection_fields_value.reduce((acc, n, index) => {
          acc[['demand_source_custom_inspection_fields_value', index, 'value'].join(',')] = n.value || '';
          return acc;
        }, {});
        return {
          ...item,
          ...newDemandSourceCustomInspectionFieldsValueObj,
        }
      }) || [];
    }, [value]);

    const [isReported, setIsReported] = useState(true);
    const onIsReportedChange = useMemoizedFn((val: boolean) => {
      if(!val && value.length > 0) {
        onChange?.([]);
      }
      setIsReported(val);
    });

    const [cardExpanded, setCardExpanded] = useState(isReported);

    useEffect(() => {
      setCardExpanded(isReported);
    }, [isReported]);

    useEffect(() => {
      if(value.length > 0) {
        setIsReported(true);
      }
    }, [value]);
    const handleAdd = useMemoizedFn(() => {
      const newCustomInspectionFieldsValue = demandSourceCustomInspection?.custom_inspection_fields?.map((n, index) => {
        return {
          ...n,
          value: '',
        }
      }) || [];
      onChange?.([...value, {
        id: uuidv4(),
        demand_source_custom_inspection_id: demandSourceCustomInspection?.id,
        main_platform: demandSourceCustomInspection?.main_platform,
        demand_source_custom_inspection_fields_value: newCustomInspectionFieldsValue
      }]);
    });

    return <ProCard
      title={<Space size={4}>
          <span>{`定制排查${index + 1}-${demandSourceCustomInspection?.main_platform}`}</span>
          <ReportedSwitch isReported={isReported} onIsReportedChange={onIsReportedChange} count={value.length} view={view} />
        </Space>}
      level={1}
      expandable={isReported}
      expanded={cardExpanded}
      onExpandedChange={setCardExpanded}
    >
      <div>
        <ProCard title={`排查要求`}
          level={2}
          noPadding
          className={cx('custom-inspection-card')}
        >
          <DescriptionsFormItem
            column={3}
            className={cx('custom-inspection-descriptions')}
            size='small'
            items={demandSourceCustomInspection?.custom_inspection_fields?.map((n, index) => {
              return {
                formItemKey: index,
                label: <EllipsisTooltip text={n.field_name || '--'} clamp={1} />,
                children: <EllipsisTooltip text={n.plan_remark || '--'} clamp={1} />
              }
            }) || []}
          />
        </ProCard>
        {(!!value?.length || !view) && <div ref={wrapperRef}>
          <ProCard title={`提报达人 (${value.length})`} level={2} noPadding rightSlot={
            <FullScreenButton
              fullRef={wrapperRef}
              handleFullChange={setIsFullscreen}
            />
          }>
            <ProTablePlusForm
              ref={localRef}
              className={cx('custom-inspection-table', {
                hidden: formatValue?.length === 0,
              }, className)}
              columns={columns}
              value={formatValue}
              rowKey="id"
              scroll={{ x: 'max-content', y: isFullscreen ?  window.innerHeight - 140 * viewBase : 560 }}
              virtual={{ maxRows: 0, useAntd: false, itemHeight: 123 }}
              toolbar={{
                actionsInTitle: true,
              }}
              hoverColor={false}
              onChange={onChange}
              verticalBorder
            />
            {!view && <div className={cx({
              'mt-2': value?.length > 0,
            },"flex justify-start items-center gap-1 w-full self-stretch shrink-0")}>
              <Space size='small'>
                <Button type='checked' icon={<Plus />} onClick={handleAdd} >添加达人</Button>
                <Button type='checked-neutral' icon={<SignIn />} onClick={handleBatchSubmission}>批量导入</Button>
              </Space>
            </div>}
          </ProCard>
        </div>}
      </div>
    </ProCard>
  }
);


type SupplierDemandSourceMatchTablesProps = {
  value?: DemandSourceSupplierKolVo[];
  onChange?: (value: DemandSourceSupplierKolVo[]) => void;
  tabsModel?: boolean;
} & SupplierDemandSourceMatchTableSingleProps;

export const SupplierDemandSourceMatchTables = forwardRef<any, SupplierDemandSourceMatchTablesProps>(
  (props, ref) => {
    const {
      value = [],
      detailData,
      onChange,
      view = false,
      tabsModel = false,
      handleBatchSubmission,
    } = props;

    // 使用 Map 存储每个子组件的 ref，key 为 demandSourceCustomInspectionId
    const childRefsMap = useRef<Map<number, ProTablePlusFormRef>>(new Map());

    const [activeTabKey, setActiveTabKey] = useState<number>(0);

    const demandSourceCustomInspectionList = useMemo(() => {
      return (detailData?.demand_source_detail_vo?.demand_source_custom_inspection_vo || []).map(n => {
        return {
          ...n,
          $demand_source_supplier_kol_vos: value?.filter(item => item.demand_source_custom_inspection_id === n.id) || [],
        }
      });
    }, [detailData?.demand_source_detail_vo?.demand_source_custom_inspection_vo, value]);

    /**
     * 处理单个自定义验收项达人列表变化的回调
     * @param value 当前自定义验收项下最新的达人列表
     * @param demandSourceCustomInspectionId 当前自定义验收项ID
     * 会将所有自定义验收项下的达人列表合并为一个总的数组，并回调 onChange
     */
    const handleChange = useMemoizedFn((value: DemandSourceSupplierKolVo[], demandSourceCustomInspectionId: number) => {
      const newValues = demandSourceCustomInspectionList.reduce((acc, item) => {
        if (item.id === demandSourceCustomInspectionId) {
          // 当前自定义验收项使用新的达人列表
          return [...acc, ...value];
        }
        // 其他自定义验收项保持原有达人列表
        return [...acc, ...(item?.$demand_source_supplier_kol_vos || [])];
      }, []) as DemandSourceSupplierKolVo[];
      onChange?.(newValues);
    });

    /**
     * 创建子组件的 ref 回调函数
     */
    const createChildRef = useMemoizedFn((demandSourceCustomInspectionId: number) => {
      return (ref: ProTablePlusFormRef | null) => {
        if (ref) {
          childRefsMap.current.set(demandSourceCustomInspectionId, ref);
        } else {
          childRefsMap.current.delete(demandSourceCustomInspectionId);
        }
      };
    });

    /**
     * 校验所有子组件的字段
     * 返回 Promise，如果所有校验都通过则 resolve，否则 reject
     */
    const validateFields = useMemoizedFn(() => {
      const validatePromises = Array.from(childRefsMap.current.values())
        .filter(ref => ref && typeof ref.validateFields === 'function')
        .map(ref => ref.validateFields());
      return Promise.all(validatePromises);
    });

    // 暴露 validateFields 方法给父组件
    useImperativeHandle(ref, () => ({
      validateFields,
    }), [validateFields]);

    
    if (!demandSourceCustomInspectionList?.length) {
      return <></>
    }

    if (tabsModel && view) {
      return <>
        <Tabs activeKey={activeTabKey.toString()} type="card" onChange={setActiveTabKey as any} className='m-b-8'>
          {
            demandSourceCustomInspectionList.map((item, index) => {
              return <Tabs.TabPane tab={`定制排查${index + 1}`} key={index}></Tabs.TabPane>
            })
          }
        </Tabs>
        <div className='flex flex-col gap-4 w-full'>
          <SupplierDemandSourceMatchTableSingle
            view={view}
            demandSourceCustomInspection={demandSourceCustomInspectionList[activeTabKey]}
            detailData={detailData}
            value={demandSourceCustomInspectionList[activeTabKey]?.$demand_source_supplier_kol_vos || []}
            index={+activeTabKey}
          />
        </div>
      </>
    }

    return <div className='flex flex-col gap-4 w-full'>
      {demandSourceCustomInspectionList.map((item, index) => (
        <div key={index} className=''>
          <SupplierDemandSourceMatchTableSingle
            key={index}
            ref={createChildRef(item.id)}
            view={view}
            demandSourceCustomInspection={item}
            detailData={detailData}
            value={item?.$demand_source_supplier_kol_vos || []}
            onChange={(value) => handleChange?.(value, item?.id)}
            index={index}
            handleBatchSubmission={handleBatchSubmission}
          />
        </div>
      ))}
    </div>
  });